import { render, staticRenderFns } from "./serviceproject.vue?vue&type=template&id=1a3ab5fa&scoped=true&"
import script from "./serviceproject.vue?vue&type=script&lang=js&"
export * from "./serviceproject.vue?vue&type=script&lang=js&"
import style0 from "./serviceproject.vue?vue&type=style&index=0&id=1a3ab5fa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3ab5fa",
  null
  
)

export default component.exports